import styled from 'styled-components';
import { MouseEvent } from 'react';
import { Flex } from 'reflexbox';
import { useTranslation } from 'react-i18next';

import { Link, useHistory } from '@treams/treams-routes';

import * as graphql from 'generated/graphql';
import SettingsTable, {
	SettingsEmptyState,
	SettingsRow,
} from 'packages/kakapo-ui-kit/components/common/SettingsTable';
import Button, { ButtonSize } from 'packages/kakapo-ui-kit/components/editors/Button';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';

const Row = styled(Link)`
	cursor: pointer;
	color: black;

	&:hover {
		background: ${(props) => props.theme.colors.lightBlueLight};
	}
`;

function LearningCertificateListItem({
	template,
}: {
	template: graphql.LearningCertificateTemplate;
}) {
	const history = useHistory();

	const url = `/settings/learning/certificates/templates/${template.id}`;

	const onEdit = (event: MouseEvent<HTMLElement>) => {
		history.push(url);
		event.preventDefault();
		event.stopPropagation();
	};

	return (
		<SettingsRow onEdit={onEdit}>
			<Row to={url}>
				<div>{template.title}</div>
			</Row>
		</SettingsRow>
	);
}

export default function LearningCertificates() {
	const { t } = useTranslation();
	const history = useHistory();

	const queries = {
		active: graphql.useLearningCertificateTemplatesQuery(),
		archive: graphql.useLearningCertificateTemplatesLazyQuery({ variables: { isArchived: true } }),
	};

	const learningCertificates = queries.active.data?.learningCertificateTemplates;

	return (
		<>
			<Flex flexDirection="column" mb={4}>
				<SettingsTable
					title={t('common.settings.learning.learningCertificateTemplates.title')}
					description={t('common.settings.learning.learningCertificateTemplates.description')}
					toolbar={
						<Button
							size={ButtonSize.Medium}
							onClick={() => {
								history.push('/settings/learning/certificates/templates/create');
							}}
						>
							{t('common.add')}
						</Button>
					}
				>
					{learningCertificates ? (
						learningCertificates.edges.length > 0 ? (
							<>
								{learningCertificates.edges.map(({ node }) => (
									<LearningCertificateListItem
										key={node.id}
										template={node as graphql.LearningCertificateTemplate}
									/>
								))}
							</>
						) : (
							<SettingsEmptyState>
								{t('common.settings.learning.learningCertificates.empty')}
							</SettingsEmptyState>
						)
					) : (
						<Spinner isLoading />
					)}
				</SettingsTable>
			</Flex>
		</>
	);
}
